import BookingsListPage from '../../shared/booking/BookingsListPage';

/** All bookings across every module. */
export default function MyTrips() {
  return <BookingsListPage title="My Trips" />;
}
